angular.module('SpidApp')

.controller('SimpleStampChoiceController',
        ['$uibModalInstance', '$scope', 'CurrencyService', 'Toaster', 'Conversion', 'ConversionRounded', 'Stamp',
function ($uibModalInstance,   $scope,   CurrencyService,   Toaster,   Conversion,   ConversionRounded,   Stamp) {
        $scope.stampChoice = {
              label      : Stamp.types.SIMPLE
            , quantity   : 1
            , price      : null
            , localPrice : null
        }

        $scope.title = $scope.stampChoice.label

        $scope.setLocalPrice = function (value) {
            $scope.stampChoice.localPrice = ConversionRounded.fromRef($scope.agency.currency, Conversion.fromRef($scope.agency.currency, +value))
        }

        $scope.setPrice = function (value) {
            $scope.stampChoice.price = Conversion.toRef($scope.agency.currency, +value)
        }
        
        $scope.modalLoaded = true;

        $scope.ok = function () {
            if (!$scope.stampChoiceForm.$valid) {
                return
            }

            var totalPrice = +$scope.stampChoice.price

            $scope.stampChoice.price 	  = +totalPrice
            $scope.stampChoice.localPrice = ConversionRounded.fromRef($scope.agency.currency, Conversion.fromRef($scope.agency.currency, +totalPrice))

            $uibModalInstance.close($scope.stampChoice)
        }
        
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel')
        }
}])
